import { createAction, createSlice } from '@reduxjs/toolkit';
import { EUnitsOfDistance } from '../../types';
import { MIN_SNAP } from '../../constants/drawerSnapPoint';

export type AppState = {
    loading: boolean;
    locale: string;
    unitsOfDistance?: EUnitsOfDistance;
    drawerSnapPoint: number | string | null;
};

const initialState: AppState = {
    loading: true,
    locale: localStorage.getItem('language') || 'en',
    unitsOfDistance:
        (localStorage.getItem('units') as EUnitsOfDistance) || EUnitsOfDistance.KILOMETERS,
    drawerSnapPoint: MIN_SNAP,
};

export const setAppLoading = createAction<boolean>('app/SetLoading');
export const setAppLocale = createAction<string>('app/SetLocale');

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setUnitsOfDistance: (state: AppState, { payload }: { payload: EUnitsOfDistance }) => {
            state.unitsOfDistance = payload;
            localStorage.setItem('units', payload);
        },
        setDrawerSnapPoint: (state: AppState, { payload }: { payload: number | string | null }) => {
            state.drawerSnapPoint = payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(setAppLoading, (state, { payload }) => {
            state.loading = payload;
        });
        builder.addCase(setAppLocale, (state, { payload }) => {
            state.locale = payload;
            state.loading = false;
            localStorage.setItem('language', payload);
        });
    },
});

export const appReducer = appSlice.reducer;

export const { setUnitsOfDistance, setDrawerSnapPoint } = appSlice.actions;
